<div style="height: 75vh; width: 35vw;overflow: hidden;">
  <div class="titleBar">
    <p class="title">Add Branch</p>
    <img (click)="CloseDialog()" style="cursor: pointer;"  src="../../../assets/images/Closex.svg" alt="" />
  </div>
  <div class="section">
    <div class="subsection">
      <p class="formLabel">
       Branch Name - English
      </p>

      <input class="formFieldMaro" />
    </div>
    <div class="subsection">
      <p class="formLabel">
        Branch Name - Arabic
      </p>

      <input class="formFieldMaro" />
    </div>
    <div class="subsection">
      <p class="formLabel">
        Number of students per branch
      </p>

      <input class="formFieldMaro" />
    </div>
    <div class="subsection">
      <p class="formLabel">
       Bank Name
      </p>

      <input class="formFieldMaro" />
    </div>
    <div class="subsection">
      <p class="formLabel">
      Bank Account Name
      </p>

      <input class="formFieldMaro" />
    </div>
    <div class="subsection">
      <p class="formLabel">
        Bank Account Number
      </p>

      <input class="formFieldMaro" />
    </div>
    <div class="subsection">
      <p class="formLabel">
        Account Currency
      </p>

      <input class="formFieldMaro" />
    </div>
    <div class="subsection">
      <p class="formLabel">
        SWIFT Code
      </p>
      <input class="formFieldMaro" />
    </div>

    <div class="buttons">
      <p class="cancelButton" (click)="CloseDialog()" >Cancel</p>
      <div class="nextButton">Save</div>
    </div>

  </div>
</div>
